import Vue from 'vue';
import constants from '../constants';
import Partner from './partner';
import FeatureSwitch from './feature-switch';
import Whitelabel from './whitelabel';
import Bus from './bus';
import ViewData from './view-data';
import LodashGet from './lodash-get';
import VueLazyLoad from 'vue-lazyload';
import VueResource from 'vue-resource';
import Vuex from 'vuex';
import VueLaroute from './laroute';
import VueNoty from 'vuejs-noty';
import Moengage from './moengage';

/**
 * Create a simple data provider plugin
 *
 * @param {String} key
 * @param {Object} object
 * @returns {{install(*): void}}
 */
export function provideVariables(key, object) {
    return {
        install(Vue) {
            Vue.prototype[key] = object;
        },
    };
}

const defaultPlugins = {
    Partner,
    Whitelabel,
    FeatureSwitch,
    Bus,
    Vuex,
    VueResource,
    ViewData,
    LodashGet,
    VueLazyLoad: [VueLazyLoad, {
        lazyComponent: true,
        lazyImage: true,
    }],
    VueNoty: [VueNoty, {
        timeout: 4000,
        progressBar: true,
        layout: 'topRight',
        theme: 'yps',
    }],
    $const: provideVariables('$const', constants),
    $laroute: VueLaroute,
    $moengage: Moengage,
};

/**
 * Load global Vue Plugins
 *
 * @param {Object} plugins
 */
export const loader = (plugins = defaultPlugins) => {
    Object.keys(plugins).forEach((plugin) => {
        let options;
        let instance = plugins[plugin];
        if (instance instanceof Array) {
            [instance, options] = instance;
        }
        Vue.use(instance, options);
    });
};
